export function numWord (value, word1, word2, word5) {
  value = Math.abs(value) % 100
  const num = value % 10
  if (value > 10 && value < 20) return word5
  if (num > 1 && num < 5) return word2
  if (num === 1) return word1
  return word5
}

/**
 * @param {Array} values
 */
export function joinNotEmpty (values, separator = ', ') {
  return values.filter((val) => !!val).join(separator)
}

/** Строка для поиска: без регистра, «ё» = «е» — «федор» находит «Фёдорова» */
export function toSearchKey (text) {
  return String(text || '').toLowerCase().replace(/ё/g, 'е')
}
